import React, { useState, useCallback, useMemo } from 'react';
import { Spin } from 'antd';
import { useSession } from 'next-auth/react';
import { useFindManyUserUploadedAssetsQuery } from '@src/components/generated/graphql';
import { FreeAssetsGridCards } from './FreeAssetsGrid';
import ModelViewerModal from '@src/components/side-bar-menu/web2-asset-store/ModelViewer';
import styles from '../add-to-scene.module.css';

export default function MyInventoryContent({ onAddToScene }) {
  const { data: session } = useSession();
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [modelUrl, setModelUrl] = useState<string>('');
  const { data, loading } = useFindManyUserUploadedAssetsQuery({
    variables: {
      where: {
        userId: {
          equals: session?.user.id!,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  const inventory = useMemo(() => {
    return data?.findManyUserUploadedAssets.map((el) => {
      return {
        ...el,
        modelType: el.assetType,
        assetURL: el.assetUrl,
        previewImage: el.previewImage,
      };
    });
  }, [data?.findManyUserUploadedAssets.length]);

  const onLoadAsset = useCallback(
    ({ assetType, name, assetUrl, previewImage }) => {
      onAddToScene({
        type: assetType,
        name: name,
        url: assetUrl,
        previewImage: previewImage,
      });
    },
    [onAddToScene]
  );

  const onOpenPreview = useCallback((url) => {
    setPreviewOpen(true);
    setModelUrl(url);
  }, []);

  if (loading) {
    return (
      <div className={styles.contentWrapper}>
        <Spin />
      </div>
    );
  }

  return (
    <div className={styles.contentWrapper}>
      {inventory?.length ? (
        <>
          <FreeAssetsGridCards
            freeAssets={inventory}
            onLoadAsset={onLoadAsset}
            onOpenPreview={onOpenPreview}
          />
        </>
      ) : (
        <div className={styles.emptyInventoryWrapper}>
          <div className={styles.emptyInventory}>
            <div className={styles.emptyInventoryContent}>
              <div className={styles.emptyInventoryIcon}>📦</div>
              <h3>Your inventory is empty</h3>
              <p>Start building your collection by uploading your own files.</p>
            </div>
          </div>
        </div>
      )}
      <ModelViewerModal
        open={previewOpen}
        setOpen={setPreviewOpen}
        modelUrl={modelUrl}
      />
    </div>
  );
}
